import { PostHogProvider } from 'posthog-js/react';

const isDev = import.meta.env.MODE === 'development';

const postHogOptions = {
  apiKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  options: {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    capture_exceptions: true,
    debug: isDev,
  },
};

export const PostHogWrapper = ({ children }: { children: React.ReactNode }) =>
  isDev ? (
    children
  ) : (
    <PostHogProvider {...postHogOptions}>{children}</PostHogProvider>
  );
